/* istanbul ignore file */
import React, { useRef } from 'react';
import { isKeyboardTriggeredEvent, toSentenceCase } from '@noths/polaris-client-utils';

import type { ImperativeRef } from 'src/components/molecules/PopoverButton/PopoverButton';
import { PopoverButton } from 'src/components/molecules/PopoverButton/PopoverButton';
import { RadioButtonGroup } from 'src/components/molecules/RadioButtonGroup/RadioButtonGroup';
import * as copy from 'src/components/organisms/FilterMenu/constants/copy';
import * as styles from 'src/components/organisms/FilterMenu/styles/SortBy.styles';
import type { ActiveSortOption, SortOptionValue } from 'src/components/organisms/FilterMenu/types';
import type { SortOption } from 'src/redux/filter/types/SortOption';

export interface SortByProps {
  activeSortOption: ActiveSortOption;
  isLoading: boolean;
  onChangeSortOption: (value: SortOptionValue) => void;
  sortOptions: SortOption[];
}

export const SortBy = ({ activeSortOption, onChangeSortOption, sortOptions }: SortByProps) => {
  const popoverButtonRef = useRef<ImperativeRef | null>(null);
  const RadioButtons = (
    <RadioButtonGroup
      accessibleLabel={copy.SORT_BY}
      hideLabel
      name={'sort-by-radio'}
      onChange={(value, event) => {
        if (!isKeyboardTriggeredEvent(event)) {
          popoverButtonRef.current?.closeContent();
        }
        onChangeSortOption(value);
      }}
      radioButtonData={sortOptions.map((option) => ({
        checked: option.active,
        labelText: toSentenceCase(option.title),
        value: option.id,
      }))}
    />
  );

  const popoverButtonMarkup = (
    <span css={styles.popoverButtonText}>
      {copy.SORT_BY}
      <span css={styles.popoverButtonOptionValue}>
        {toSentenceCase(activeSortOption?.title || '')}
      </span>
    </span>
  );

  return (
    <PopoverButton buttonMarkup={popoverButtonMarkup} ref={popoverButtonRef}>
      <div css={styles.popoverContent}>{RadioButtons}</div>
    </PopoverButton>
  );
};
